export default "__VITE_ASSET__B3wQuShc__"